"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _solarReact = require("@solar/solar-react");

var _InspectorInfo = _interopRequireDefault(require("./InspectorInfo"));

var _excluded = ["inspector", "history", "loading", "handleUserClick", "handleOnboarding", "action", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InspectorSheet = function InspectorSheet(_ref) {
  var inspector = _ref.inspector,
      history = _ref.history,
      loading = _ref.loading,
      handleUserClick = _ref.handleUserClick,
      handleOnboarding = _ref.handleOnboarding,
      action = _ref.action,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var name = inspector.name,
      cover = inspector.cover;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.CoverView, {
    title: name,
    action: action,
    cover: cover && cover.src
  }, /*#__PURE__*/_react["default"].createElement(_InspectorInfo["default"], _extends({
    inspector: inspector,
    onUserClick: handleUserClick,
    onStartOnboarding: handleOnboarding,
    loading: loading,
    labels: _objectSpread(_objectSpread({}, labels.info), {}, {
      actions: labels.actions,
      status: labels.status
    })
  }, other)));
};

var _default = InspectorSheet;
exports["default"] = _default;